import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _objectToOfferMap;

import { dropdownSeparator } from '../types';
import { EOfferType } from './offerTypeSelectorOptions';
/**
 * Взято из lead-realtor-form /v1/get-form
 * question: objectType{Flat|SuburbanWithLand|Commercial}
 * @see question.answers
 * */

export var EObjectTypeFlat;

(function (EObjectTypeFlat) {
  EObjectTypeFlat["Flat"] = "flat";
  EObjectTypeFlat["Room"] = "room";
})(EObjectTypeFlat || (EObjectTypeFlat = {}));

export var EObjectTypeSuburban;

(function (EObjectTypeSuburban) {
  EObjectTypeSuburban["House"] = "house";
  EObjectTypeSuburban["Cottage"] = "cottage";
  EObjectTypeSuburban["Townhouse"] = "townhouse";
  EObjectTypeSuburban["HouseShare"] = "houseShare";
  EObjectTypeSuburban["Land"] = "land";
})(EObjectTypeSuburban || (EObjectTypeSuburban = {}));

export var EObjectTypeCommercial;

(function (EObjectTypeCommercial) {
  EObjectTypeCommercial["Office"] = "office";
  EObjectTypeCommercial["ShoppingArea"] = "shoppingArea";
  EObjectTypeCommercial["FreeAppointmentObject"] = "freeAppointmentObject";
  EObjectTypeCommercial["Industry"] = "industry";
  EObjectTypeCommercial["Warehouse"] = "warehouse";
  EObjectTypeCommercial["Garage"] = "garage";
  EObjectTypeCommercial["CommercialLand"] = "commercialLand";
})(EObjectTypeCommercial || (EObjectTypeCommercial = {}));

export var objectToOfferMap = (_objectToOfferMap = {}, _defineProperty(_objectToOfferMap, EObjectTypeFlat.Flat, EOfferType.Flat), _defineProperty(_objectToOfferMap, EObjectTypeFlat.Room, EOfferType.Flat), _defineProperty(_objectToOfferMap, EObjectTypeSuburban.House, EOfferType.Suburban), _defineProperty(_objectToOfferMap, EObjectTypeSuburban.Cottage, EOfferType.Suburban), _defineProperty(_objectToOfferMap, EObjectTypeSuburban.Townhouse, EOfferType.Suburban), _defineProperty(_objectToOfferMap, EObjectTypeSuburban.HouseShare, EOfferType.Suburban), _defineProperty(_objectToOfferMap, EObjectTypeSuburban.Land, EOfferType.Suburban), _defineProperty(_objectToOfferMap, EObjectTypeCommercial.Office, EOfferType.Commercial), _defineProperty(_objectToOfferMap, EObjectTypeCommercial.ShoppingArea, EOfferType.Commercial), _defineProperty(_objectToOfferMap, EObjectTypeCommercial.FreeAppointmentObject, EOfferType.Commercial), _defineProperty(_objectToOfferMap, EObjectTypeCommercial.Industry, EOfferType.Commercial), _defineProperty(_objectToOfferMap, EObjectTypeCommercial.Warehouse, EOfferType.Commercial), _defineProperty(_objectToOfferMap, EObjectTypeCommercial.Garage, EOfferType.Commercial), _defineProperty(_objectToOfferMap, EObjectTypeCommercial.CommercialLand, EOfferType.Commercial), _objectToOfferMap);
export var objectTypeFlatSelectorOptions = [{
  value: EObjectTypeFlat.Flat,
  selectedLabel: 'Квартира',
  label: 'Квартира'
}, {
  value: EObjectTypeFlat.Room,
  selectedLabel: 'Комната',
  label: 'Комната'
}];
export var objectTypeSuburbanSelectorOptions = [{
  value: EObjectTypeSuburban.House,
  selectedLabel: 'Дом/Дача',
  label: 'Дом/Дача'
}, {
  value: EObjectTypeSuburban.Cottage,
  selectedLabel: 'Коттедж',
  label: 'Коттедж'
}, {
  value: EObjectTypeSuburban.Townhouse,
  selectedLabel: 'Таунхаус',
  label: 'Таунхаус'
}, {
  value: EObjectTypeSuburban.HouseShare,
  selectedLabel: 'Часть дома',
  label: 'Часть дома'
}, {
  value: EObjectTypeSuburban.Land,
  selectedLabel: 'Участок',
  label: 'Участок'
}];
export var objectTypeCommercialSelectorOptions = [{
  value: EObjectTypeCommercial.Office,
  selectedLabel: 'Офис',
  label: 'Офис'
}, {
  value: EObjectTypeCommercial.ShoppingArea,
  selectedLabel: 'Торговая площадь',
  label: 'Торговая площадь'
}, {
  value: EObjectTypeCommercial.FreeAppointmentObject,
  selectedLabel: 'Помещение свободного назначения',
  label: 'Помещение свободного назначения'
}, {
  value: EObjectTypeCommercial.Industry,
  selectedLabel: 'Производство',
  label: 'Производство'
}, {
  value: EObjectTypeCommercial.Warehouse,
  selectedLabel: 'Склад',
  label: 'Склад'
}, {
  value: EObjectTypeCommercial.Garage,
  selectedLabel: 'Гараж',
  label: 'Гараж'
}, {
  value: EObjectTypeCommercial.CommercialLand,
  selectedLabel: 'Коммерческая земля',
  label: 'Коммерческая земля'
}];
export var objectTypeSelectorOptionsCombined = [].concat(objectTypeFlatSelectorOptions, [{
  value: dropdownSeparator,
  selectedLabel: '',
  label: ''
}], objectTypeSuburbanSelectorOptions, [{
  value: dropdownSeparator,
  selectedLabel: '',
  label: ''
}], objectTypeCommercialSelectorOptions);